export enum QuoteStatus {
  Accepted = 'accepted',
  Created = 'created',
  Deleted = 'deleted',
  Invoiced = 'invoiced',
  Open = 'open',
  Rejected = 'rejected',
  Sent = 'sent',
  Unsent = 'unsent',
}
